module.exports = __webpack_public_path__ + "static/media/zam6.4a71ccaf.jpg";